import React, { useState } from 'react';
import UploadComponent from './components/UploadComponent';
import TableComponent from './components/TableComponent';

function App() {
  const [responseData, setResponseData] = useState(null);

  const handleDataReceived = (data) => {
    // data is the full API response object
    setResponseData(data && typeof data === 'object' && !Array.isArray(data) ? data : null);
  };

  return (
    <div className="app-wrapper">
      <div className="container py-4">
        <div className="app-header mb-4">
          <h1 className="app-title">BalanceSheet</h1>
          <p className="app-subtitle">Upload your Excel file to view balance sheet data</p>
        </div>
        <UploadComponent onDataReceived={handleDataReceived} />
        <TableComponent
          data={responseData?.data || []}
          companyName={responseData?.companyName || ''}
          year={responseData?.year || ''}
          totalDebit={responseData?.totalDebit ?? null}
          totalCredit={responseData?.totalCredit ?? null}
          previousYearLabel={responseData?.previousYearLabel || ''}
        />
      </div>
    </div>
  );
}

export default App;
